document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ccw]').forEach(initPicker);
});

function initPicker(root) {
  var field = root.querySelector('[data-ccw-field]');
  var handle = root.querySelector('[data-ccw-handle]');
  var hueSlider = root.querySelector('[data-ccw-hue]');
  var hexInput = root.querySelector('[data-ccw-hex]');
  var preview = root.querySelector('[data-ccw-preview]');
  var hiddenInput = root.querySelector('[data-ccw-hidden]');

  if (!field) return;

  var state = { h: 14, s: 65, v: 71 };

  function hsvToHex(h, s, v) {
    s /= 100;
    v /= 100;
    var c = v * s;
    var x = c * (1 - Math.abs((h / 60) % 2 - 1));
    var m = v - c;
    var r = 0, g = 0, b = 0;

    if (h < 60) { r = c; g = x; b = 0; }
    else if (h < 120) { r = x; g = c; b = 0; }
    else if (h < 180) { r = 0; g = c; b = x; }
    else if (h < 240) { r = 0; g = x; b = c; }
    else if (h < 300) { r = x; g = 0; b = c; }
    else { r = c; g = 0; b = x; }

    var toHex = function (val) {
      var hex = Math.round((val + m) * 255).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };

    return '#' + toHex(r) + toHex(g) + toHex(b);
  }

  function hexToHsv(hex) {
    hex = hex.replace('#', '');
    if (hex.length !== 6) return null;
    var r = parseInt(hex.substr(0, 2), 16) / 255;
    var g = parseInt(hex.substr(2, 2), 16) / 255;
    var b = parseInt(hex.substr(4, 2), 16) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var d = max - min;
    var h = 0;

    if (d !== 0) {
      if (max === r) h = 60 * (((g - b) / d) % 6);
      else if (max === g) h = 60 * ((b - r) / d + 2);
      else h = 60 * ((r - g) / d + 4);
    }
    if (h < 0) h += 360;

    var s = max === 0 ? 0 : d / max;
    var v = max;

    return { h: h, s: s * 100, v: v * 100 };
  }

  function positionHandle() {
    var rect = field.getBoundingClientRect();
    var x = (state.s / 100) * rect.width;
    var y = (1 - state.v / 100) * rect.height;
    handle.style.left = x + 'px';
    handle.style.top = y + 'px';
  }

  function syncOutputs() {
    var hex = hsvToHex(state.h, state.s, state.v);
    if (hiddenInput) hiddenInput.value = hex;
    if (hexInput) hexInput.value = hex;
    if (preview) preview.style.background = hex;
    field.style.setProperty('--hue', state.h);
  }

  function pickFromEvent(e) {
    var rect = field.getBoundingClientRect();
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
    var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    var y = Math.min(Math.max(clientY - rect.top, 0), rect.height);
    state.s = (x / rect.width) * 100;
    state.v = 100 - (y / rect.height) * 100;
    handle.style.left = x + 'px';
    handle.style.top = y + 'px';
    syncOutputs();
  }

  var dragging = false;
  field.addEventListener('pointerdown', function (e) {
    dragging = true;
    pickFromEvent(e);
  });
  window.addEventListener('pointermove', function (e) {
    if (dragging) pickFromEvent(e);
  });
  window.addEventListener('pointerup', function () {
    dragging = false;
  });

  if (hueSlider) {
    hueSlider.addEventListener('input', function () {
      state.h = Number(hueSlider.value);
      syncOutputs();
    });
  }

  if (hexInput) {
    hexInput.addEventListener('change', function () {
      var parsed = hexToHsv(hexInput.value);
      if (!parsed) return;
      state = parsed;
      if (hueSlider) hueSlider.value = Math.round(state.h);
      positionHandle();
      syncOutputs();
    });
  }

  positionHandle();
  syncOutputs();
}